<app-menu-toggle
  tooltip="Event browser"
  icon="event-browser"
  [active]="showEventBrowser"
  (click)="toggleOverlay()"
>
</app-menu-toggle>
